import React from "react";
import { Modal } from "react-bootstrap";
import { FaCalendarAlt, FaClock, FaMapMarkerAlt } from "react-icons/fa";

const EventModal = ({ show, handleClose, event }) => {
  if (!event) return null;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="modal-header-custom">
        <Modal.Title>{event.title}</Modal.Title>
        <button className="close-btn" onClick={handleClose}>×</button>
      </Modal.Header>

      <Modal.Body>
        <p><FaCalendarAlt /> 26 Jul, 2024 - 31 Jul, 2024</p>
        <p><FaClock /> 11:00 AM - 12:15 PM</p>
        <p><FaMapMarkerAlt /> Las Vegas, US</p>

        <p className="mt-3">
          A recurring event occurs more than once on your calendar.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default EventModal;